var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "introduction_page" },
    [
      _c("div", { staticClass: "head_box" }, [
        _vm._m(0),
        _c("div", { staticClass: "head_content" }, [
          _c("img", {
            staticClass: "img1",
            attrs: {
              src: require("../../static/images/saasIntroduction/img1.png"),
              alt: ""
            }
          }),
          _c("div", { staticClass: "content_card" }, [
            _c("p", { staticClass: "title" }, [_vm._v("电子签约业务定制系统")]),
            _c("div", { staticClass: "tip" }, [
              _vm._v(
                "\n          以君子签电子合同签约系统为基础，区块链技术为核心，可根据企业实际需求灵活适配业务场景，从签约流程到数据管理实现全链路自定义。前端服务可与网站、公众号等整合集成，后台电子签约管理系统支持多账号管理、权限设置及数据导出，并支持个性化的业务数据报表定制以满足企业所需。适合有一定个性化需求，但却没有开发能力的中小微企业使用。\n        "
              )
            ]),
            _c(
              "div",
              { staticClass: "btn" },
              [
                _c("div", { staticClass: "text" }, [
                  _vm._v(
                    "针对行业不同的业务场景，提供适合自身情况的专属业务定制系统"
                  )
                ]),
                _c(
                  "el-button",
                  {
                    staticStyle: { width: "200px" },
                    attrs: { type: "primary" },
                    on: { click: _vm.applyFn }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.ywtApplyStatus === 0 ? "审核中" : "申请开通")
                    )
                  ]
                )
              ],
              1
            )
          ])
        ])
      ]),
      _vm._m(1),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "提示",
            visible: _vm.introductionVisible,
            width: "30%",
            "show-close": false
          },
          on: {
            "update:visible": function($event) {
              _vm.introductionVisible = $event
            }
          }
        },
        [
          _c("p", [_vm._v("请联系企业管理员申请开通。")]),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: {
                    click: function($event) {
                      _vm.introductionVisible = false
                    }
                  }
                },
                [_vm._v("确定")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "head_top" }, [
      _c("img", {
        staticClass: "img",
        attrs: { src: require("../../static/images/logoNew.png"), alt: "" }
      }),
      _c("span", { staticClass: "text" }, [_vm._v("业务定制系统")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "main_box" }, [
      _c("ul", { staticClass: "list_ul" }, [
        _c("li", { staticClass: "list_li" }, [
          _c("p", { staticClass: "btn_class" }, [_vm._v("双方录入")]),
          _c("span", [
            _vm._v(
              "可按需配置电子合同模板，合同模板支持单、双方录入签约信息，同时支持针对签约方身份信息核验、签署意愿认证等。从模板创建到签约全流程无缝衔接，用“零门槛自定义+智能合规校验”，让每个企业都能快速拥有专属电子合同“生产线”，高效又省心！"
            )
          ])
        ]),
        _c("li", { staticClass: "list_li" }, [
          _c("p", { staticClass: "btn_class" }, [_vm._v("前置业务首页")]),
          _c("span", [
            _vm._v(
              "可根据用户需求自定义创建前置业务首页，集业务展示、分类浏览、电子合同签署、费用支付为一体，灵活多变，操作简单。快速生成“业务展示+签约支付”一站式入口，用极简操作实现个性化业务门户自由，让每个企业都能拥有会“说话”的专属数字前台！"
            )
          ])
        ]),
        _c("li", { staticClass: "list_li" }, [
          _c("p", { staticClass: "btn_class" }, [_vm._v("批量业务发起")]),
          _c("span", [
            _vm._v(
              "支持业务模板批量发起，多个业务模板相同变量一次录入，全模板可用，无需重复填写，省时省力。业务场景自由适配，一次操作全模板生效，用极简交互实现“填一次，用百次”的省心体验，大幅提升多模板处理效率，让企业流程管理更轻松！"
            )
          ])
        ]),
        _c("li", { staticClass: "list_li" }, [
          _c("p", { staticClass: "btn_class" }, [_vm._v("业务模板管理")]),
          _c("span", [
            _vm._v(
              "通过可视化界面即可自由搭建匹配业务流程的模板体系——从合同正文内容、变量规则到审批流程嵌入、签约设置，全模块支持自定义配置，像拼搭专属“业务流程图”一样，轻松将纸质流程转化为数字化模板。"
            )
          ])
        ])
      ]),
      _c("div", { staticClass: "main_img" }, [
        _c("img", {
          staticClass: "img2",
          attrs: {
            src: require("../../static/images/saasIntroduction/img2.png"),
            alt: ""
          }
        }),
        _c("img", {
          staticClass: "img2",
          attrs: {
            src: require("../../static/images/saasIntroduction/img3.png"),
            alt: ""
          }
        })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7f5ffa0c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f5ffa0c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/ywtRelated/introductionPage.vue
// module id = mxos
// module chunks = 171